export function hireTopSlider() {
    $(".hire-top-grid").each(function () {
        let curSliderWrap = $(this);
        let curSlider = curSliderWrap.find(".swiper-container");


        
		
        // var swiperOptions = {
        //     // slidesPerView: 3,
        //     // slidesPerGroup: 3,
        //     // grid: {
        //     //     rows: 2,
        //     // },
        //     direction:'horizontal',
        //     centeredSlides: false,
        //     slidesPerView : 3, 
        //     slidesPerColumn : 2,
        //     slidesPerGroup : 3,
        //     loopFillGroupWithBlank : false,
        //     spaceBetween: 30,
        //     pagination: {
        //         el: `.${curSliderWrap.find(".swiper-pagination").attr("class")}`,
        //         clickable: true,
        //     }
        // };

        // var swiper = new Swiper(`.${curSlider.attr("class")}`, swiperOptions);
    });

    $('.hire-top-slider').slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 1,
        arrows: false,
        dots: true,
        mobileFirst: true,  
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    rows: 2,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    rows: 3,
                }
            },
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    rows: 2,
                }
            }
        ]
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/hire-top-slider.js